<template>
  <div id="app" class="c-plan-form__wrapper">

    <!-- Contain the boosted modal of eSim and where to find the iccid number -->
    <ExplanationsModal
      v-for="(modal, name, index) in popinList"
      :key="name + index"
      :type="name"
      :modal="modal"
      :traduction="traduction" />

    <StickyHeader
      :traduction="traduction"
      :plan-data-from-magento="planDataFromMagento" />

    <MobileLayout
      v-if="isMobile"
      :traduction="traduction"
      v-on:validate-plan="validatePlan"
      :option-group-to-update="optionGroupToUpdate"
      :plan-data-from-magento="planDataFromMagento" />

    <DesktopLayout
      v-if="isDesktop || isTablet"
      :traduction="traduction"
      v-on:validate-plan="validatePlan"
      :option-group-to-update="optionGroupToUpdate"
      :plan-data-from-magento="planDataFromMagento" />

  </div>
</template>

<script>

import store from '~src/store/Plans'
import DesktopLayout from '~plans/Layout/DesktopLayout.vue'
import MobileLayout from '~plans/Layout/MobileLayout.vue'
import StickyHeader from '~plans/StickyHeader.vue'
import ExplanationsModal from '~plans/ExplanationsModal.vue'

import Helpers from '~plugins/Helpers'

export default {
    store,
  name: 'Plans',
  components: {
    MobileLayout,
    DesktopLayout,
    StickyHeader,
    ExplanationsModal
  },
  props: {
    planDataFromMagento: {
      type: Object,
      default: () => {}
    },
    traduction: {
      type: Function,
      default: (trad) => trad
    }
  },
  computed: {
    isProd () {
      return Helpers.isProd()
    },
    $t () {
      return this.traduction
    }
  },
  data () {
    return {
      isDesktop: false,
      isMobile: false,
      isTablet: false,
      popinList: {},
      optionGroupToUpdate: ''
    }
  },
  beforeMount () {
    this.popinList = {...planDataFromMagento.plan.esim_blocks, iccid_popin: {...planDataFromMagento.plan.iccid_block}}

    if (Helpers.getParamValue('option_group') && Helpers.getParamValue('option_group') !== '') {
      this.optionGroupToUpdate = Helpers.getParamValue('option_group')
    }
  },
  mounted () {
    if (!this.isProd) {
      let element = document.createElement("link");
      element.setAttribute("rel", "stylesheet");
      element.setAttribute("type", "text/css");
      element.setAttribute("href", process.env.BASE_URL + 'css/theme.css');
      document.getElementsByTagName("head")[0].appendChild(element);
    }

    this.isDesktop = Helpers.isDesktop()
    this.isMobile = Helpers.isMobile()
    this.isTablet = Helpers.isTablet()

     const self = this
    /**
     * Update Anowave GTM plugin ( update the dataLayer ) when the user add a product to his cart.
     * If the user comes from a devices we add the device like an additionnal product
     */
    AEC.EventDispatcher.on('ec.add.data', function(data) {
      if (self.planDataFromMagento.isFromDevice && data.ecommerce.add.products[0].additional_product !== 'Yes') {
        data.ecommerce.add.products[0].additional_product = 'Yes'
        data.ecommerce.add.products[0].additional_product_brand = 'Orange'
        data.ecommerce.add.products[0].additional_product_category = 'Téléphone'
        data.ecommerce.add.products[0].additional_product_name = self.planDataFromMagento.isFromDevice
        data.ecommerce.add.products[0].additional_product_price = self.planDataFromMagento.plan.sticky_prices.price
        data.ecommerce.add.products[0].additional_product_variant = AEC.Storage.get('VariantFromDevice')
        return data
      }
    })
  },
  created () {
    window.addEventListener('resize', this.resizeEvent);
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeEvent);
  },
  methods: {
    resizeEvent () {
      this.isDesktop = Helpers.isDesktop()
      this.isMobile = Helpers.isMobile()
      this.isTablet = Helpers.isTablet()
    },
    validatePlan (planData) {
      const dataFromMagento = this.planDataFromMagento.plan.custom_options

      // if addtocart is not available, it means the user came back from the checkout when he choose to update his custom options
      // so the addToCart button change in updatecart button
      const addToCart = document.querySelector('#product-addtocart-button') ? document.querySelector('#product-addtocart-button') : document.querySelector('#product-updatecart-button')

      const isHomebox = this.planDataFromMagento.plan.categorization === 'homebox'
        let isFibre = false;

        if (planData.sim.plan) {
            isFibre = planData.sim.plan.categorization === 'fibre';
        }

      if (isHomebox) {
        const modem = document.querySelector(Helpers.generateNameAndValueSelector(planData.sim.option_id, planData.sim.option_type_id))
        modem.checked = true
      } else if (isFibre) {
          // planData.options.map(item => {
          //     const key = Object.keys(item)[0];
          //
          //     if (key === 'fixe' && item['fixe'].state === true) {
          //         const phoneNumber = Helpers.getInputBySpanText(planData.phoneNumber.name)
          //         phoneNumber.checked = true;
          //         return;
          //     } else if (key === 'fixe' && item['fixe'].state === false) {
          //         const phoneNumber = Helpers.getInputBySpanText('None')
          //         phoneNumber.checked = true;
          //         return;
          //     }
          //
          //     if (item[key].state === true) {
          //         const checkbox = Helpers.getInputBySpanText(item[key].option.name)
          //         checkbox.checked = true;
          //     } else {
          //         const checkbox = Helpers.getInputBySpanText(item[key].option.name)
          //         checkbox.checked = false;
          //     }
          // })
      } else {
          const phoneNumber = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_number.option_id))
          let provider = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_operator.option_id))

          const portabilityDate = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_date.option_id))
          const iccid = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_sim.option_id))
          // We execute this code only if the user has checked "keep his phone" else we reset the field to send empty string to avoid error
          // in the following field : phoneNumber, provider, portabilityDate, iccid
          if (planData && 'phoneNumber' in planData.phoneNumber) {
              // Make sure there is the prefix LU before sended the phoneNumber
              if (planData.phoneNumber.phoneNumber.includes('+352')) {
                  phoneNumber.value = planData.phoneNumber.phoneNumber
              } else {
                  phoneNumber.value = '+352 ' + planData.phoneNumber.phoneNumber
              }

              for (let i = 0; i < provider.childNodes.length; i++) {
                  if (provider.childNodes[i].innerText === 'Tango') {
                      provider.childNodes[i].selected = true
                  } else {
                      provider.childNodes[1].selected = true
                  }
              }

              provider.value = planData.phoneNumber.provider

              // Transform french date to en-US locale to avoid backend error
              if (planData.phoneNumber.portabilityDate.includes('/')) {
                  const frenchDate = planData.phoneNumber.portabilityDate
                  const splittedFrenchDate = frenchDate.split('/')
                  const newUniversalFormat = `${splittedFrenchDate[2]}-${splittedFrenchDate[1]}-${splittedFrenchDate[0]}`
                  portabilityDate.value = newUniversalFormat
              } else {
                  portabilityDate.value = planData.phoneNumber.portabilityDate
              }

              iccid.value = planData.phoneNumber.iccid
          } else {
              phoneNumber.value = ''

              for (let i = 0; i < provider.childNodes.length; i++) {
                  provider.childNodes[i].selected = false
              }

              provider.value = ''

              portabilityDate.value = ''
              iccid.value = ''
          }
      }

      if (!isHomebox && !isFibre) {
        let planOption = document.querySelector(Helpers.generateNameAndValueSelector(planData.phoneNumber.option_id, planData.phoneNumber.option_type_id))
        planOption.checked = true
      }

       /**
       * Sim is mandatory for every plan
       */
      let sim = document.querySelector(Helpers.generateNameAndValueSelector(planData.sim.option_id, planData.sim.option_type_id))

      if (isHomebox) sim = document.querySelector(Helpers.generateNameSelector(dataFromMagento.sim_type.option_id))

      if(!isFibre) sim.checked = true

      const urlWithoutParams = window.location.protocol + '//' + window.location.host + window.location.pathname
      /**
       * We remove the params from the url before submitting the form in case, when the user go the cart and decide to go back to this page for whatever reason
       * We need to remove the params to avoid displaying the configurator first, instead we display the default page
       *
       * fromVueJsApp = variable shared between the PlansPage.js,
       */
      window.history.pushState({fromVueJsApp: true}, '', urlWithoutParams)

      addToCart.click()

      $(document).on('customer-data-reload', (event, data) => {
        // if data includes cart it means the cart is updated
        // so we redirect to the checkout
        if (data.includes('cart')) {
          window.location.href = this.planDataFromMagento.cartUrl
        }
      })
    }
  }
}
</script>
